
import { HeartPulse } from "lucide-react";
import { Breadcrumb, BreadcrumbItem, BreadcrumbLink, BreadcrumbList, BreadcrumbPage, BreadcrumbSeparator } from "@/components/ui/breadcrumb";
import { useTranslations } from "@/hooks/useTranslations";
import { useLanguagePath } from "@/utils/language";

export const AssessmentsHeader = () => {
  const { t } = useTranslations("assessments");
  const { getPath } = useLanguagePath();
  
  return (
    <div className="space-y-4 animate-fade-in">
      <div className="flex flex-col sm:flex-row justify-between items-start sm:items-center gap-4 pb-4 border-b border-slate-100/50">
        <div className="space-y-2">
          <h2 className="text-3xl font-bold tracking-tight gradient-text">{t("title")}</h2>
          <p className="text-muted-foreground">{t("subtitle")}</p>
          <Breadcrumb className="flex-wrap">
            <BreadcrumbList>
              <BreadcrumbItem>
                <BreadcrumbLink href={getPath("/student-dashboard")} className="text-flame hover:text-flame/80">Dashboard</BreadcrumbLink>
              </BreadcrumbItem>
              <BreadcrumbSeparator />
              <BreadcrumbItem>
                <BreadcrumbPage className="font-medium">{t("title")}</BreadcrumbPage>
              </BreadcrumbItem>
            </BreadcrumbList>
          </Breadcrumb>
        </div>
      </div>
    </div>
  );
};
